import { Component, OnInit, Input, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { ChoiceDataElement } from '../../../core/elements/models/choice-data-element-model';
import { ChoiceElement } from '../assist-data-element.component';
import { SelectedCondition } from '../../../core/models/executed-result.model';
const $ = require('jquery');
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SimulatorEngineService } from '../../../core/services/simulator-engine.service';
@Component({
  selector: 'acr-assist-choice-element',
  template: `<form [formGroup]="choiceElementForm" novalidate>
  <div class="form-group">
    <div class="col-sm-5 text-right">
      <label class="control-label break-word">
        {{choiceDataElement.label}} <span *ngIf="choiceDataElement.unit != undefined && choiceDataElement.unit != ''"> ({{choiceDataElement.unit}})</span>
      </label>
      <ng-container *ngIf="choiceDataElement.hint !== '' && choiceDataElement.hint !== undefined">
        <i class="whitespace">
          <span class="fa fa-info-circle text-primary" data-toggle="tooltip" data-placement="right" title="{{choiceDataElement.hint}}"></span>
        </i>
      </ng-container>
      <ng-container *ngIf="choiceDataElement.diagrams != undefined ">
        <acr-hint-diagram [dataElement]="choiceDataElement" [imagePath]="imagePath"></acr-hint-diagram>
      </ng-container>
      <span *ngIf="choiceElementForm.controls['checkBox'].invalid  && this.choiceDataElement.isRequired" class="required-field whitespace"
        title="Required Field">*</span>
    </div>
    
    <div class="col-sm-7 text-left content-padding">
      <ng-container *ngIf="choiceDataElement.choiceInfo.length <= 2">
        <ng-container *ngIf="imagePath != undefined">
          <ng-container *ngIf="choiceDataElement.imageMap == undefined">
            <ng-container *ngFor="let choice of choiceDataElement.choiceInfo">
              <div class="radio custom-radio-style">
                <label>                
                  <input [attr.disabled]="choiceDataElement.isEditable == false ? 'disabled' : null" [(ngModel)]="choiceValue" id="{{choice.value}}_{{choiceDataElement.id}}" type="radio" formControlName="checkBox" value="{{choice.value}}"
                    (change)="choiceSelected(choiceDataElement.id, choiceDataElement.label, (choice.reportText !== undefined) ? choice.reportText : choice.label, choice.value)"> {{choice.label}}
                </label>
              </div>
            </ng-container>
            <ng-container *ngIf="choiceDataElement.allowFreetext">
              <div class="radio custom-radio-style">
                <label>
                  <input [attr.disabled]="choiceDataElement.isEditable == false ? 'disabled' : null" id="other_{{choiceDataElement.id}}" type="radio" formControlName="checkBox" value="freetext" (change)="choiceSelected(choiceDataElement.id, choiceDataElement.label, 'Other', 'freetext')"> Other, please specifyâ¦</label>
              </div>
              <div id='div_{{choiceDataElement.id}}_other'>
                <input [attr.disabled]="choiceDataElement.isEditable == false ? 'disabled' : null" id="txt_other_{{choiceDataElement.id}}" class="form-control" type="text" formControlName="checkBox" value="other"
                  class="form-control" (keyup)='updateFreeText($event.target, choiceDataElement.id, choiceDataElement.label)'
                  placeholder="Please specify '{{choiceDataElement.label}}'">
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="choiceDataElement.imageMap != undefined">
            <div class="row">
              <div class="col-xs-6 col-sm-2">
                <ng-container *ngFor="let choice of choiceDataElement.choiceInfo">
                  <div class="radio custom-radio-style">
                    <label>
                      <input [attr.disabled]="choiceDataElement.isEditable == false ? 'disabled' : null" [(ngModel)]="choiceValue" id="{{choice.value}}_{{choiceDataElement.id}}" type="radio" formControlName="checkBox" value="{{choice.value}}"
                        (change)="choiceSelected(choiceDataElement.id, choiceDataElement.label, (choice.reportText !== undefined) ? choice.reportText : choice.label, choice.value)"> {{choice.label}}
                    </label>
                  </div>
                </ng-container>
                <ng-container *ngIf="choiceDataElement.allowFreetext">
                  <div class="radio custom-radio-style">
                    <label>
                      <input [attr.disabled]="choiceDataElement.isEditable == false ? 'disabled' : null" id="other_{{choiceDataElement.id}}" type="radio" formControlName="checkBox" value="other" (change)="choiceSelected(choiceDataElement.id, choiceDataElement.label, 'Other', 'freetext')"> Other, please specifyâ¦</label>
                  </div>
                  <div id='div_{{choiceDataElement.id}}_other'>
                    <input  [attr.disabled]="choiceDataElement.isEditable == false ? 'disabled' : null" id="txt_other_{{choiceDataElement.id}}" class="form-control" type="text" formControlName="checkBox" value="other"
                      class="form-control" (keyup)='updateFreeText($event.target, choiceDataElement.id, choiceDataElement.label)'
                      placeholder="Please specify '{{choiceDataElement.label}}'">
                  </div>
                </ng-container>
              </div>
              <div class="col-xs-6 col-sm-2">
                <label class="control-label">OR</label>
              </div>
              <acr-image-map [DataElement]="choiceDataElement" [imagePath]="imagePath"></acr-image-map>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    
      <ng-container *ngIf="choiceDataElement.choiceInfo.length > 2">            
        <select [attr.disabled]="choiceDataElement.isEditable == false ? 'disabled' : null"
         [(ngModel)]="choiceValue" id="{{choiceDataElement.id}}" (change)="dropdownChoiceSelected($event.target, choiceDataElement.label)"
          formControlName="checkBox" class="form-control">
          <!-- <option 
          [selected]="choiceDataElement.currentValue == choiceDataElement.ChoiceNotRelevant ? true : false">--Select--</option>
         -->
           <option [selected]="
          choiceDataElement.ChoiceNotRelevant != undefined ?
          (choiceDataElement.ChoiceNotRelevant.indexOf(choiceDataElement.currentValue) > -1 ? 
          true :
          true)
          : true">--Select--</option>

          <!-- [selected]="choice.value === choiceDataElement.currentValue" -->

        
          <option *ngFor="let choice of choiceDataElement.choiceInfo"
          [hidden]="choiceDataElement.ChoiceNotRelevant != undefined ? 
              choiceDataElement.ChoiceNotRelevant.indexOf(choice.value) > -1 ? true: null
              : null"
          [value]="choice.value"   
          [selected]="choiceDataElement.ChoiceNotRelevant != undefined ?
           choiceDataElement.ChoiceNotRelevant.indexOf(choiceDataElement.currentValue) > -1
           || choiceDataElement.ChoiceNotRelevant.indexOf(choice.value) > -1? false : 
           choice.value === choiceDataElement.currentValue ? true : false
           : choice.value === choiceDataElement.currentValue ? true : false"       
          >{{choice.label}}</option>
          <option *ngIf="choiceDataElement.allowFreetext" [value]="'freetext'" [selected]="'freetext'">Other, please specifyâ¦</option>
        </select>
        <div id='div_{{choiceDataElement.id}}_other'>

          <input id="txt_other_{{choiceDataElement.id}}" class="form-control" type="text" formControlName="checkBox" value="other"
            placeholder="Please specify '{{choiceDataElement.label}}'" (keyup)='updateFreeText($event.target, choiceDataElement.id, choiceDataElement.label)'>
        </div>
        <ng-container *ngIf="choiceDataElement.imageMap != undefined  && imagePath != undefined">
          <div class="row padding-top-10">
            <div class="col-xs-6 col-sm-2">
              <label class="control-label">OR</label>
            </div>
            <acr-image-map [DataElement]="choiceDataElement" [imagePath]="imagePath"></acr-image-map>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</form>

`,
  styles: [``, `.required-field{color:red}.padding-l-5{padding-left:5px}.whitespace{margin-left:5px}.max-w-h-100{max-width:100%;max-height:100%}.carousel-control>.fa{font-size:40px;position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-20px}.carousel-control.left{background-repeat:repeat-x}.carousel-control.left,.carousel-control.right{background-image:none}.carousel-control.right{background-image:linear-gradient(to right,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5) 100%);background-repeat:repeat-x}.scroll{overflow-y:scroll;overflow-x:hidden}.div-simulator-form-height{height:calc(100vh - 100px);overflow-y:scroll;overflow-x:hidden}.div-report-text-scroll{overflow-x:hidden;overflow-y:auto;max-height:calc(100vh - 300px)}.padding-r-10{padding-right:10px}.slide-left{left:30px}.slide-right{right:30px}hr{margin-top:10px;margin-bottom:10px}.white-space-line{white-space:pre-line;word-wrap:break-word}p{margin:0 0 10px}.form-control{border-radius:0;box-shadow:none;border-color:#d2d6de}h4.modal-title.float-left{float:left}.margin-b-0{margin-bottom:0}.font-weight-400{font-weight:400}.custom-radio-style{float:left;margin-right:15px}.zoom{width:100%;overflow:auto}.zoom img{height:auto;width:100%;min-width:100%;max-width:inherit!important}.btn-zoom{background-color:#f4f4f4;color:#444;border-color:#ddd}.btn-zoom.hover,.btn-zoom:active,.btn-zoom:hover{background-color:#e7e7e7}@media (min-width:768px){label.control-label{padding-left:20px}}.padding-5{padding:5px}`]
})
export class AssistChoiceElementComponent implements OnInit, AfterViewInit {
  @Input() choiceDataElement: ChoiceDataElement;
  @Input() imagePath: string;
  @Output() returnChoiceElement = new EventEmitter();
  @Output() choiceChange = new EventEmitter();
  choiceValue: string;

  choiceElementForm: FormGroup;
  selectedCondition: SelectedCondition;
  selectedIndex: number;
  selectedChoiceReportText: string;
  selectedChoiceReportLabel: string;
  @Input() disabled: boolean;

  constructor(private formBuilder: FormBuilder, private simulatorEngineService: SimulatorEngineService) { }
  ngOnInit(): void {
    this.createChoiceElementForm();
  }

  ngAfterViewInit(): void {
    $('#div_' + this.choiceDataElement.id + '_other').hide();
    if (this.choiceDataElement.currentValue !== undefined) {
      $('#' + this.choiceDataElement.currentValue + '_' + this.choiceDataElement.id).prop('checked', true);
      this.choiceValue = this.choiceDataElement.currentValue;
      // tslint:disable-next-line:forin
      for (const choice in this.choiceDataElement.choiceInfo) {
        // if (this.choiceDataElement.choiceInfo[choice].value === 'hypoEnhancing'){
        //     console.log('asdasd');
        // }

        if (this.choiceDataElement.choiceInfo[choice].value === this.choiceDataElement.currentValue) {
          if (this.choiceDataElement.choiceInfo[choice].reportText !== undefined) {
            this.selectedChoiceReportText = this.choiceDataElement.choiceInfo[choice].reportText;
          } else {
            this.selectedChoiceReportLabel = this.choiceDataElement.choiceInfo[choice].label;
          }
        }
      }

      if (this.choiceDataElement.choiceInfo.length <= 5) {
        this.updateChoiceValue(this.choiceDataElement.id, this.choiceDataElement.label,
          (this.selectedChoiceReportText !== undefined) ? this.selectedChoiceReportText : this.selectedChoiceReportLabel, this.choiceDataElement.currentValue);
      } else {
        this.updateDropdownChoiceSelected(this.choiceDataElement.id, this.selectedChoiceReportLabel, this.choiceDataElement.currentValue, this.choiceDataElement.label);
      }
    } else {
      this.returnChoiceElement.emit(undefined);
    }
  }

  updateChoiceValue(elementId: string, selectedElement: string, selectedText: string, selectedValue: string) {
    if (selectedValue !== undefined) {
      const choiceElement = new ChoiceElement();
      choiceElement.elementId = elementId;
      choiceElement.selectedValue = selectedValue;
      choiceElement.selectedText = selectedText;
      this.showOrHideFreeText(elementId, choiceElement.selectedValue);

      this.selectedCondition = new SelectedCondition();

      this.selectedCondition.selectedConditionId = elementId;
      this.selectedCondition.selectedCondition = selectedElement;
      this.selectedCondition.selectedValue = selectedText;

      this.returnChoiceElement.emit({ receivedElement: choiceElement, selectedCondition: this.selectedCondition });
    }
  }

  updateDropdownChoiceSelected(elementId, elementLabel, elementValue, selectedCondition) {
    const choiceElement = new ChoiceElement();
    choiceElement.elementId = elementId;
    choiceElement.selectedValue = elementValue;
    choiceElement.selectedText = elementLabel;

    if (this.choiceValue === 'undefined' || this.choiceValue === '--Select--' || this.choiceValue === undefined || this.choiceValue === '') {
      choiceElement.selectedText = '';
      choiceElement.selectedValue = '';
    }

    this.selectedCondition = new SelectedCondition();

    this.selectedCondition.selectedConditionId = elementId;
    this.selectedCondition.selectedCondition = selectedCondition;
    this.selectedCondition.selectedValue = elementLabel;
    this.returnChoiceElement.emit({ receivedElement: choiceElement, selectedCondition: this.selectedCondition });
  }

  choiceSelected(elementId: string, selectedElement: string, selectedText: string, selectedValue: string) {
    const choiceElement = new ChoiceElement();
    choiceElement.elementId = elementId;
    choiceElement.selectedValue = selectedValue;
    choiceElement.selectedText = selectedText;
    this.showOrHideFreeText(elementId, choiceElement.selectedValue);

    this.selectedCondition = new SelectedCondition();

    this.selectedCondition.selectedConditionId = elementId;
    this.selectedCondition.selectedCondition = selectedElement;
    this.selectedCondition.selectedValue = selectedText;
    this.returnChoiceElement.emit({ receivedElement: choiceElement, selectedCondition: this.selectedCondition });
  }

  dropdownChoiceSelected(element, selectedCondition) {
    const choiceElement = new ChoiceElement();
    choiceElement.elementId = element.id;
    choiceElement.selectedValue = (element.options[element.selectedIndex].text === 'Other, please specifyâ¦') ? 'freetext' : element.value;
    choiceElement.selectedText = element.options[element.selectedIndex].text;

    this.showOrHideFreeText(element.id, choiceElement.selectedValue);

    if (this.choiceValue === 'undefined' || this.choiceValue === '--Select--' || this.choiceValue === undefined || this.choiceValue === '') {
      choiceElement.selectedText = '';
      choiceElement.selectedValue = '';
    }

    this.selectedCondition = new SelectedCondition();

    this.selectedCondition.selectedConditionId = element.id;
    this.selectedCondition.selectedCondition = selectedCondition;
    this.selectedCondition.selectedValue = element.options[element.selectedIndex].text;

    // Code should comes here //
    this.returnChoiceElement.emit({ receivedElement: choiceElement, selectedCondition: this.selectedCondition });
  }

  private createChoiceElementForm() {
    this.choiceElementForm = this.formBuilder.group({
      checkBox: ['', Validators.required],
    }, {
        validator: this.specificValueInsideRange('checkBox')
      });
  }

  showOrHideFreeText(elementId: string, selectedValue: string) {
    if (selectedValue === 'freetext') {
      $('#div_' + elementId + '_other').show();
    } else {
      $('#div_' + elementId + '_other').hide();
      $('#txt_other_' + elementId).val('');
    }
  }

  updateFreeText(element, elementId, selectedCondition) {
    const choiceElement = new ChoiceElement();
    choiceElement.elementId = elementId;
    choiceElement.selectedValue = (element.value === 'Other') ? 'freetext' : element.value;
    choiceElement.selectedText = element.value;

    this.selectedCondition = new SelectedCondition();

    this.selectedCondition.selectedConditionId = elementId;
    this.selectedCondition.selectedCondition = selectedCondition;
    this.selectedCondition.selectedValue = element.value;
    this.returnChoiceElement.emit({ receivedElement: choiceElement, selectedCondition: this.selectedCondition });
  }
  private specificValueInsideRange(checkBoxKey: string) {
    return (group: FormGroup) => {
      const choiceControl = group.controls[checkBoxKey];
      if ((choiceControl.value === undefined || choiceControl.value === '' || choiceControl.value === '--Select--' || this.choiceValue === '')) {
        return choiceControl.setErrors({ notEquivalent: true });
      } else {
        return choiceControl.setErrors(null);
      }
    };
  }
}
